import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import LocationCreateUpdate, { LocationCreateUpdateProps } from "./LocationCreateUpdate";

export interface OwnProps {
  createUpdateProps: LocationCreateUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function LocationCreateUpdateModal({ createUpdateProps, ...dialogProps }: Props) {
  const isCreate = !createUpdateProps.locationId;

  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {isCreate ? "Create new" : "Edit"} location
      </AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <LocationCreateUpdate {...createUpdateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
